import type { DeclarationFilters, ReleaseFilters, BondFilters, TariffResource, TariffFilters } from '../types';

export const carmKeys = {
  all: ['carm'] as const,
  declarations: (filters?: DeclarationFilters) => [...carmKeys.all, 'declarations', filters] as const,
  releases: (filters?: ReleaseFilters) => [...carmKeys.all, 'releases', filters] as const,
  bonds: (filters?: BondFilters) => [...carmKeys.all, 'bonds', filters] as const,
  tariffs: (resource: TariffResource, filters?: TariffFilters) => [...carmKeys.all, 'tariffs', resource, filters] as const,
};
